'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.axios = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _Promise = typeof Promise === 'undefined' ? require('es6-promise').Promise : Promise;

var hasLocalStorage = typeof localStorage !== 'undefined';

var Request = function Request(method, parameters) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return Request._list[method](method, parameters, options);
};

Request._sources = {};
Request._list = [];
Request._defaultHeaders = {};

Request.attachDefaultHeaders = function () {
  var headers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var registerOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _defaultHeaders = Request._defaultHeaders;
  var token = _defaultHeaders.token;

  var attachToken = params.attach_token === undefined ? true : params.attach_token;

  if (hasLocalStorage) {
    var localToken = localStorage.getItem('token');
    !localToken && token && localStorage.setItem('token', token);

    if (registerOptions.headers && registerOptions.headers.application) {
      var applicationToken = localStorage.getItem('token' + registerOptions.headers.application);
      applicationToken && localStorage.setItem('token', applicationToken);
    }

    token = localStorage.getItem('token');
  }

  if (token && attachToken) {
    _defaultHeaders.Authorization = 'Bearer ' + token;
    if (headers && headers.Authorization) delete headers.Authorization;
  }

  delete _defaultHeaders.token;

  var requestReaders = _extends({}, _defaultHeaders, headers);

  if (!attachToken) {
    delete requestReaders.Authorization;
  }

  return requestReaders;
};

Request.setDefaultHeaders = function (headers) {
  Request._defaultHeaders = headers;
};

Request._buildMethodFn = function (type, apiPath, apiData, registerOptions) {
  return function (method, parameters, options) {
    var cancelToken = _axios2.default.CancelToken;
    var source = cancelToken.source();
    Request._sources[method] = source;

    var config = {};
    var configRequest = {};
    var url = apiData;

    if ((typeof apiData === 'undefined' ? 'undefined' : _typeof(apiData)) === 'object') {
      url = apiData.path;
      configRequest = apiData.options;
    }

    var headers = Request.attachDefaultHeaders(configRequest.headers, parameters, registerOptions);
    configRequest.headers = headers;

    if ((typeof parameters === 'undefined' ? 'undefined' : _typeof(parameters)) === 'object') {
      if (parameters.attach_token) {
        delete parameters.attach_token;
      }

      for (var param in parameters) {
        this[param] = parameters[param];
        var urlParam = ':' + param;

        if (url.indexOf(urlParam) >= 0) {
          url = url.replace(urlParam, parameters[param]);
          delete parameters[param];
        }
      }
    }

    if (type === 'get' && parameters) {
      config.params = parameters;
    } else {
      config.data = parameters;
    }

    config.method = type;
    config.url = url;
    config = _extends({}, config, registerOptions, options, configRequest, {
      cancelToken: source.token,
      headers: _extends({}, registerOptions.headers, options.headers, configRequest.headers)
    });

    if (config && config.headers) {
      if (config.headers['Content-Type'] === 'application/x-www-form-urlencoded' && parameters) {
        config.data = _qs2.default.stringify(parameters);
      } else if (config.headers['Content-Type'] === 'multipart/form-data') {
        var form_data = new FormData();

        for (var key in parameters) {
          form_data.append(key, parameters[key]);
        }

        config.data = form_data;
      }
    }

    config.url = apiPath + config.url;

    return new _Promise(function (resolve, reject) {
      (0, _axios2.default)(config).then(function (response) {
        return resolve(response.data);
      }).catch(function (error) {
        return reject(error);
      }).then(function () {
        return delete Request._sources[method];
      });
    });
  };
};

Request.register = function (apiPath, methodsList) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  for (var method in methodsList) {
    var info = methodsList[method];
    for (var key in info) {
      var apiData = info[key];
      Request._list[key] = Request._buildMethodFn(method, apiPath, apiData, options);
    }
  }
};

Request.onError = function (callback) {
  _axios2.default.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    if (typeof callback !== 'undefined') {
      callback(error);
    }

    return _Promise.reject(error);
  });
};

Request.cancelAll = function () {
  for (var method in Request._sources) {
    Request.cancel(method);
  }
};

Request.cancel = function (method) {
  var source = Request._sources[method];
  if (!method || !source) return;
  source.cancel(method + ' cancelled');
};

_axios2.default.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  return _Promise.reject(error);
});

exports.axios = _axios2.default;
exports.default = Request;
